import validate from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import check_45auth_45global from "/var/www/cellcom/production/frontend/src/middleware/checkAuth.global.js";
import manifest_45route_45rule from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  check_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}